<template>
  <v-list
      class="py-0"
      :dense="$vuetify.breakpoint.mobile"
      v-if="settings.isShowNumberOrder"
  >
    <v-subheader>Номер заказа</v-subheader>
    <v-skeleton-loader
        v-if="loading"
        type="list-item-avatar-two-line"
    >
    </v-skeleton-loader>

    <v-list-item
        v-else-if="buyoutItem"
        two-line
    >
      <v-list-item-avatar>
        <v-icon class="warning white--text">mdi-information-outline</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="warning--text">
          {{buyoutItem.orderNumber}}
        </v-list-item-title>
        <v-list-item-subtitle>Сообщите этот номер в момент получения заказа</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'BuyoutItemInfoOrderNumber',
  props: {
    buyoutItem: {
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    },
    settings: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>